module.exports = __webpack_public_path__ + "img/empty_table.5769e965.png";